import Vue from 'vue';

export default {
  setUser(state, user) {
    state.user = user;

    // Set user information for monitoring
    if (user != null) {
      state.bugsnagClient.user = {
        id: user.uid,
        email: user.email,
        name: user.displayName,
      };
    }
  },

  setUserData(state, userData) {
    // set fields that were added later to prevent errors
    if (userData !== null) {
      if (typeof userData.currentGroup !== 'undefined') {
        state.currentGroup = userData.currentGroup;
      }

      if (userData.hasOwnProperty('settings')) {
        if (userData.settings.hasOwnProperty('backgroundImage')) {
          state.backgroundImage = userData.settings.backgroundImage;
        }

        if (userData.settings.hasOwnProperty('backgroundOpacity')) {
          state.backgroundOpacity = userData.settings.backgroundOpacity;
        }
      }
    }

    state.userData = userData;
  },

  setUserName(state, userName) {
    state.userData.name = userName;
  },

  /**
   * Adds the passed id of a fight to list of fights
   * for this user.
   *
   * @param state
   * @param fightId
   */
  addFightToUser(state, fightId: string) {
    state.userData.fights.push(fightId);
  },

  setCurrentGroup(state, groupId) {
    state.currentGroup = groupId;
  },

  setCurrentGroupData(state, groupData) {
    state.currentGroupData = groupData;
  },

  addGroup(state, group) {
    const index = state.groups.findIndex((existingGroup) => {
      return existingGroup.id === group.id;
    });
    if (index === -1) {
      state.groups.push(group);
    } else {
      Vue.set(state.groups, index, group);
    }
  },

  setSaving(state, isSaving) {
    state.isSaving = isSaving;

    if (isSaving) {
      state.lastSave = Math.round(new Date().getTime() / 1000);
    }
  },

  addMessage(state, message) {
    const messageObject = {
      id: Math.round(Math.random() * 100000),
      message,
    };
    state.messages.push(messageObject);
  },

  removeLastMessage(state) {
    state.messages.shift();
  },

  changeBackground(state, payload) {
    state.backgroundImage = payload.background;
    state.backgroundOpacity = payload.opacity;
  },
};
